import { render } from "./TheCookieBanner.vue?vue&type=template&id=415acbfb"
import script from "./TheCookieBanner.vue?vue&type=script&lang=js"
export * from "./TheCookieBanner.vue?vue&type=script&lang=js"

import "./TheCookieBanner.vue?vue&type=style&index=0&id=415acbfb&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__